import React from 'react';
import { FormHelperText, Grid, Icon, Typography } from '@material-ui/core';

import { ClientContext } from '../../../ClientContext';
import { EditAction } from '../../../../../shared/enum/EditAction';
import { Alert } from '@material-ui/lab';
import { CutoutOrganogramList } from './CutoutOrganogramList';
import { ClientErrorContext } from '../../../ClientErrorContext';
import { OrganogramModel } from '../../../../../Models/OrganogramModel';

export function CutoutModalOrganogram() {

    const clientContext = React.useContext(ClientContext);
    const clientErrorContext = React.useContext(ClientErrorContext);
    
    const list = clientContext.cutoutOrganogram;
    const parentOrganogram = list.reduce<Record<number, OrganogramModel>>((acc, org) => {
    acc[org.id] = org;
    return acc;
    }, {});

    list.forEach(org => {
        if (org.editAction === EditAction.SELECTED) {
            let current = org;
            while (current.parentId !== null) {
                current = parentOrganogram[current.parentId];
                if (current) {
                    current.editAction = EditAction.SELECTED;
                } else {
                    break;
                }
            }
        }
    });
    clientContext.setCutoutOrganogram(list);
    
    const getDescription = () => {
        return (
            <>
                <Grid item xs={12}>
                    <Alert severity="warning" icon={<Icon>warning_amber</Icon>}>
                        Ao selecionar um nível, os subníveis serão considerados também no recorte. <br />
                        Para selecionar apenas um subnível, expanda o nível e selecione o subnível desejado.
                    </Alert>
                </Grid>
                {clientErrorContext.organogramNotSelectedInCutoutError &&
                    clientContext.cutoutOrganogram.filter(o => o.editAction == EditAction.SELECTED).length == 0 && (
                    <Grid item xs={12}>
                        <FormHelperText error id="organogram-not-selected">
                            {'É necessário selecionar ao menos um nível do organograma.'}
                        </FormHelperText>
                    </Grid>
                )}
            </>
        );
    };

    const getOrganogram = () => {
        return (
            <CutoutOrganogramList
                listOrg={clientContext.cutoutOrganogram}
                parent={null}
                level={1}
                textLevel={''} />
        );
    };

    return (
        <Grid container spacing={3}>
            {getDescription()}
            {getOrganogram()}
        </Grid>
    );
}